import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import parse from 'html-react-parser';
import { useMemo } from 'react';
import { sanitizeHtml } from 'utils/sanitizeHtml';
/**
 * Represents a component that safely parses and renders an html string as a
 * react component.
 */
export const HtmlRenderer = ({ html, sanitizationProfileType, replace, }) => {
    const htmlComponent = useMemo(() => {
        const sanitizedHtml = sanitizeHtml(html, sanitizationProfileType);
        return parse(sanitizedHtml, {
            replace,
        });
    }, [html, sanitizationProfileType, replace]);
    return _jsx(_Fragment, { children: htmlComponent });
};
